import { render, staticRenderFns } from "./modalAddAutomatedNotification.vue?vue&type=template&id=1e58a464&"
import script from "./modalAddAutomatedNotification.vue?vue&type=script&lang=js&"
export * from "./modalAddAutomatedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports